/**
 * The chat's author-role colours (ChatThread ROLE_COLORS) as TEXT, derived by one rule.
 *
 * They are identity hues -- who wrote this message -- set inline on the author's name and avatar initials. They were
 * picked for the dark theme, and on paper every one of them is unreadable as text (client #B292B3 2.3:1, admin
 * #B5A882 2.0:1 on the paper fill); the editor teal is also 4.23:1 on the lightest dark ground. Same shape as the
 * status fills (lib/statusChart.js) and LIGHT_TIER_INK (lib/api.js): keep the hue, step the lightness until the
 * text clears 4.5:1 against the WORST ground a name sits on in that theme -- the palest dark ground and the
 * darkest light one, so it clears on all of them. A role added later inherits it.
 */
import { chartFill } from './statusChart.js';

export const ROLE_COLORS = { admin: '#B5A882', staff: '#849B7B', editor: '#478B89', client: '#B292B3' };
export const ROLE_TEXT_FLOOR = 4.5;
// the grounds a name or avatar initial sits on: page/card/fill in each theme (site-look.css palette). The rule
// steps against the one that is hardest for text.
export const ROLE_GROUNDS = { dark: ['#101010', '#171717', '#1e1e1e'], light: ['#f4f4f5', '#ffffff', '#ebebed'] };
const WORST = { dark: '#1e1e1e', light: '#ebebed' };

// The AVATAR's circle is the role colour at this alpha (hex, appended to the colour: ChatThread paints it from here).
// Initials sit ON that wash, which is a harder ground than the page in both themes: lighter than the darkest dark
// ground, darker than the paper. Measured 2026-09-29 when editors got the look: "JC" 4.45:1 dark, 4.27:1 light, "SM"
// 4.33:1 light, because the rule stepped against the plain grounds only. So the step is taken against the WASH over
// the worst ground, and names (which sit on the plain ground) clear with room to spare.
export const AVATAR_WASH_HEX = '15';
const mix = (ground, colour, a) => '#' + [1, 3, 5].map(i => Math.round(
  parseInt(ground.slice(i, i + 2), 16) * (1 - a) + parseInt(colour.slice(i, i + 2), 16) * a)
  .toString(16).padStart(2, '0')).join('');
export const avatarGround = (role, isLight) =>
  ROLE_COLORS[role] ? mix(WORST[isLight ? 'light' : 'dark'], ROLE_COLORS[role], parseInt(AVATAR_WASH_HEX, 16) / 255) : undefined;

export function roleInk(role, isLight) {
  const base = ROLE_COLORS[role];
  if (!base) return undefined;
  return chartFill(base, avatarGround(role, isLight), ROLE_TEXT_FLOOR);
}
